<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { vOnClickOutside } from '@vueuse/components';

const props = defineProps({
  inboxes: { type: Array, required: true },
  modelValue: { type: [Number, String], default: null },
});
const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const isOpen = ref(false);

const selectedInbox = computed(() =>
  props.inboxes.find(inbox => inbox.id === props.modelValue)
);

const buttonLabel = computed(
  () =>
    selectedInbox.value?.name ||
    t('REPORT_DASHBOARD.INBOX_SELECTOR.ALL_INBOXES')
);

const selectInbox = id => {
  emit('update:modelValue', id);
  isOpen.value = false;
};
</script>

<template>
  <div
    v-on-click-outside="() => (isOpen = false)"
    class="relative inline-block"
  >
    <button
      type="button"
      class="px-3 py-1 text-xs uppercase tracking-wide border border-n-weak text-n-slate-11"
      @click="isOpen = !isOpen"
    >
      {{ buttonLabel }}
    </button>

    <div
      v-if="isOpen"
      class="absolute z-10 mt-1 w-56 max-h-64 overflow-y-auto border border-n-strong bg-n-solid-1 p-2 shadow-lg text-left"
    >
      <button
        type="button"
        class="block w-full text-left py-1 text-sm text-n-slate-12 hover:text-n-slate-11"
        @click="selectInbox(null)"
      >
        {{ t('REPORT_DASHBOARD.INBOX_SELECTOR.ALL_INBOXES') }}
      </button>
      <button
        v-for="inbox in inboxes"
        :key="inbox.id"
        type="button"
        class="block w-full text-left py-1 text-sm text-n-slate-12 hover:text-n-slate-11"
        @click="selectInbox(inbox.id)"
      >
        {{ inbox.name }}
      </button>
      <p v-if="!inboxes.length" class="py-1 text-sm text-n-slate-11">
        {{ t('REPORT_DASHBOARD.INBOX_SELECTOR.NO_INBOXES_FOUND') }}
      </p>
    </div>
  </div>
</template>
